function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import orderBy from 'lodash.orderby';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import generalRouteService from '@rd-web-markets/shared/dist/services/general_route.service';
import generalRouteSubRouteService from '@rd-web-markets/shared/dist/services/general_route_subroute.service';
const competentProfessionalProjectTemplateService = {
  useImportStatus(companyId) {
    let forNewProjectCreation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const [data, setData] = useState([]);
    const [importStatus, setImportStatus] = useState({});
    const [searchQuery, setSearchQuery] = useState('');
    const [intervalId, setIntervalId] = useState(null);
    const {
      report_id
    } = useParams();
    const getImportStatusAndCompetentProfessionalData = useErrorHandling(useCallback(async () => {
      const response = await this.getImportStatus(companyId);
      if (response === null) {
        setImportStatus({
          import_status: 'never_imported'
        });
      } else {
        setImportStatus(_objectSpread({}, response));
      }
      if ((response === null || response === void 0 ? void 0 : response.import_status) !== 'pending') {
        if (!forNewProjectCreation) {
          competentProfessionalProjectTemplateService.useGetStaffCost(companyId, setData, report_id);
        }
      }
      return response;
    }, [companyId, forNewProjectCreation, report_id]));
    const importTemplate = useErrorHandling(useCallback(async body => {
      const response = await this.importCompetentProfessionalTemplate(companyId, body, report_id);
      setImportStatus(_objectSpread({}, response));
    }, [companyId, report_id]));
    useEffect(() => {
      if (importStatus.import_status === 'pending' && !intervalId) {
        const currentId = setInterval(() => {
          getImportStatusAndCompetentProfessionalData();
        }, 4000);
        setIntervalId(currentId);
      } else if (importStatus.import_status !== 'pending' && !!intervalId) {
        clearInterval(intervalId);
        setIntervalId(null);
      }
      return () => {
        clearInterval(intervalId);
      };
    }, [getImportStatusAndCompetentProfessionalData, importStatus.import_status, intervalId, report_id]);
    useEffect(() => {
      getImportStatusAndCompetentProfessionalData();
    }, [getImportStatusAndCompetentProfessionalData]);
    useEffect(() => {
      if (!forNewProjectCreation) {
        competentProfessionalProjectTemplateService.useGetStaffCost(companyId, setData, report_id);
      }
    }, [companyId, forNewProjectCreation, report_id]);
    return [data, setData, importStatus, importTemplate, report_id, searchQuery, setSearchQuery];
  },
  async useGetStaffCost(companyId, setData, selectedProjectId) {
    let searchQuery = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    setData([]);
    const response = await competentProfessionalProjectTemplateService.getCompetentProfessionals(companyId, selectedProjectId, 'competent_professionals', searchQuery);
    const responseOrderedById = orderBy(response, ['id'], ['asc']);
    setData([...responseOrderedById]);
  },
  useExportTemplate(selectedProjectId, companyId) {
    const companyRoute = "/api/companies/".concat(companyId, "/export_competent_professional_template");
    const projectRoute = "/api/claim_project_reports/".concat(selectedProjectId, "/export_competent_professional_template");
    const route = selectedProjectId ? projectRoute : companyRoute;
    window.open(route);
  },
  getCompetentProfessionals(companyId) {
    let selectedProjectId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    let route = arguments.length > 2 ? arguments[2] : undefined;
    let searchQuery = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    const finalSearchQuery = "?search=".concat(searchQuery);
    if (selectedProjectId) {
      return generalRouteSubRouteService.getAll(selectedProjectId, 'claim_project_reports', 'competent_professionals', finalSearchQuery);
    } else {
      const finalRoute = "".concat(route).concat(finalSearchQuery);
      return generalRouteService.getAll("/companies/".concat(companyId, "/").concat(finalRoute));
    }
  },
  getImportStatus(companyId) {
    return generalRouteService.getAll("companies/".concat(companyId, "/import_competent_professional_templates"));
  },
  importCompetentProfessionalTemplate(companyId, body) {
    let claimProjectReportId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return generalRouteService.postFormData("/companies/".concat(companyId, "/import_competent_professional_templates?project_id=") + claimProjectReportId, body);
  }
};
export default competentProfessionalProjectTemplateService;